import React, { useMemo } from 'react';
import { Button, CircularProgress, Grid, Typography, makeStyles } from '@material-ui/core';
import { useIsMobile } from '../../../components/Mui3WidthProvider';
import YesFreeTrail from '../../../resources/yes-free-trial-text.png'
import { SubscriptionPlan, Subscriptionterm } from '../../../entities/SubscriptionPlan';

interface PricingTableProps {
    onChangePlan: (term: Subscriptionterm) => void;
    selectedPlan: SubscriptionPlan;
    costOfPlan: string;
    couponValue: string | undefined
    disabled: boolean;
    trialAllowed: boolean;
}

export function PricingTable(props:PricingTableProps){
    const isMobile = useIsMobile();
    const classes = useStyles();
    const { selectedPlan, disabled, costOfPlan, trialAllowed, couponValue } = props;
    const isMonthly = useMemo(() => selectedPlan.subscriptionTerm === Subscriptionterm.Monthly, [selectedPlan]);

    return (
        <Grid item xs={12}>
            <div style={{ border: "1px solid #ececec", padding: 14, backgroundColor: "#FFF", borderRadius: "4px" }}>
                <Grid container direction="row" alignItems="center" justifyContent="center" alignContent="center" wrap="nowrap" style={{paddingBottom: 15}}>
                    <Grid item>
                        <Button			
                            variant="outlined"
                            size="small"
                            type="submit"
                            className={classes.button}
                            style={{ borderRadius: "2px 0 0 2px" }}
                            disabled={isMonthly || disabled}
                            onClick={() => props.onChangePlan(Subscriptionterm.Monthly)}>Monthly</Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            size="small"
                            type="submit"
                            className={classes.button}
                            style={{ borderRadius: "0 2px 2px 0" }}
                            disabled={!isMonthly || disabled}
                            onClick={() => props.onChangePlan(Subscriptionterm.Annual)}>Annual</Button>
                    </Grid>
                    <Grid item style={{ paddingLeft: 4}}>
                        <img width="100%" style={{ visibility: isMonthly ? "hidden" : "visible"}}
                                src={YesFreeTrail}
                                alt={"Yes, you have a free trial"}
                        />
                    </Grid>
                </Grid>
                <div style={{ padding: 5 }}>
                    <Grid container direction="row" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="subtitle1" style={{ opacity: .8 }}>
                                { selectedPlan.crossedOutPriceText }
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle1" style={{ opacity: .8, textDecoration: "line-through" }}>
                                { selectedPlan.crossedOutPriceValue }
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" justifyContent="space-between" style={{ marginTop: 10 }}>
                        <Grid item>
                            <Typography variant="subtitle1" style={{ opacity: .8, color: "rgb(50, 153, 57)", fontStyle: "oblique" }}>
                                { selectedPlan.showedDiscountText }
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle1" style={{ opacity: .8, color: "rgb(50, 153, 57)", fontStyle: "oblique" }}>
                                { selectedPlan.showedDiscountValue }
                            </Typography>
                        </Grid>
                    </Grid>
                    {couponValue &&
                        <Grid container direction="row" justifyContent="space-between" style={{ marginTop: 10 }}>
                            <Grid item>
                                <Typography variant="subtitle1" style={{ opacity: .8, color: "rgb(50, 153, 57)", fontStyle: "oblique" }}>
                                    Coupon Applied
                            </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="subtitle1" style={{ opacity: .8, color: "rgb(50, 153, 57)", fontStyle: "oblique" }}>
                                    -{couponValue}
                                </Typography>
                            </Grid>
                        </Grid>
                    }
                    {!couponValue && props.trialAllowed &&
                        <Grid container direction="row" justifyContent="space-between" style={{ marginTop: 10 }}>
                            <Grid item>
                                <Typography variant="subtitle1" style={{ opacity: .8 }}>
                                   {selectedPlan.displayedTotalText}
                            </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="subtitle1" style={{ opacity: .8 }}>
                                    {selectedPlan.displayedTotalValue}
                                </Typography>
                            </Grid>
                        </Grid>
                    }
                    <hr style={{ marginTop: 10 }} />
                    <Grid style={{ paddingTop: 6, marginTop: isMobile ? 0 : 15 }} container direction="row" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="subtitle1" style={{ opacity: .9 }}>
                                {trialAllowed && !couponValue
                                    ? <b>Your Price Today</b>
                                    : <b>Your Total</b>
                                }
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle1" style={{ opacity: .9 }}>
                                { trialAllowed && !isMonthly
                                    ?<b>$0.00</b>
                                    :<b>{costOfPlan}</b>
                                }
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    loading: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1),
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block'
    },
    button: {
        backgroundColor: "rgb(250, 250, 250) ",
        padding: "8px 15px",
        "&:hover": {
            backgroundColor: "rgb(50, 153, 57, .8)",
        },
        "&:disabled": {
            backgroundColor: "rgb(50, 153, 57)",
            color: "#FFF",
        },
        [theme.breakpoints.down('xs')]: {
            padding: "4px 7px",
        }
    },
}));